// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","main":"App_main__uN9ca"};